import '../../less/registration-common.less';
import { Icon } from 'antd';

export default class RecoveryStatus extends React.Component {
    constructor(props) { super(props); }
    render() {
        const 
        { recoveryCode, status, pendingCallback, successCallback, failureCallback, preComponentCallback } = this.props,
        iconStyle = { fontSize: '1.5em', marginRight: '8px' };
        //console.log(JSON.stringify(this.props));
        //console.log("Status file: " +status);
        //console.log("Status file: " +recoveryCode);
        switch(status) {
            case 'pending': 
                if(pendingCallback) pendingCallback(status);
                return (
                    <div className='ss-cmpts-reg-common-container'>
                        <Icon type='loading' style={iconStyle} />
                        <span className='ss-cmpts-reg-common-title'>
                            {'Attempting to submit request...'}
                        </span>
                    </div>
                )
        

            case 'success': 
                if (successCallback) successCallback(status);
                return (
                    <div className='ss-cmpts-reg-common-container'>
                        <Icon type='check-circle' style={iconStyle} />
                        <span className='ss-cmpts-reg-common-title'>
                            {'Recovery request was successfully created.'}
                        </span>
                    </div>
                );
            
            case 'failure':
                switch(recoveryCode) {
                    case 406:
            //check duplicates
            //to add new error check, do case (error code)    
                        return (
                            <div className='ss-cmpts-reg-common-container'>
                                <Icon type='close-circle' style={iconStyle} />
                                <span className='ss-cmpts-reg-common-title'>
                                    {'Failure to submit request.'}
                                </span>
                            </div>
                        );

                    case 409:
                        return (
                            <div className='ss-cmpts-reg-common-container'>
                                <Icon type='close-circle' style={iconStyle} />
                                <span className='ss-cmpts-reg-common-title'>
                                    {'Username and email matched with two separate accounts. Username and email must belong to the same account. Recovery request failed.'}
                                </span>
                            </div>
                        );

                    case 410:
                        return (
                            <div className='ss-cmpts-reg-common-container'>
                                <Icon type='close-circle' style={iconStyle} />
                                <span className='ss-cmpts-reg-common-title'>
                                    {'No Existing Account matches username or email.'}
                                </span>
                            </div>
                    
                        );

                    default: return (
                        <div className='ss-cmpts-reg-common-container'>
                            <Icon type='close-circle' style={iconStyle} />
                            <span className='ss-cmpts-reg-common-title'>
                                {'Failure to submit request.'}
                            </span>
                        </div>
                    );
                }
               
            default: return (
                <div className='ss-cmpts-reg-common-container'>
                    <Icon type='close-circle' style={iconStyle} />
                    <span className='ss-cmpts-reg-common-title'>
                        {'Failure to submit request.'}
                    </span>
                </div>
            );
        }
    }
}